var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('alert',{attrs:{"type":"warning"}},[_vm._v(" This list will not be updated. For future transaction history please contact your collections agency. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }